/* eslint-disable import/prefer-default-export */
import React from 'react'
import PropTypes from 'prop-types'

export function Saved({ className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
    >
      <path
        d="M12.913 17.5L6.99996 13.8043L1.08691 17.5V1.23913C1.08691 1.0431 1.16479 0.8551 1.3034 0.716486C1.44201 0.577873 1.63001 0.5 1.82604 0.5H12.1739C12.3699 0.5 12.5579 0.577873 12.6965 0.716486C12.8351 0.8551 12.913 1.0431 12.913 1.23913V17.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

Saved.propTypes = {
  className: PropTypes.string,
}

Saved.defaultProps = {
  className: '',
}
